import { render, staticRenderFns } from "./PayrollQueue.vue?vue&type=template&id=781c30ca&"
import script from "./PayrollQueue.vue?vue&type=script&lang=js&"
export * from "./PayrollQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports